import React from 'react';
import { Link } from 'react-router-dom';
import Bluedots from '../../assets/images/blue_dotes.png'
import howstep1 from '../../assets/images/howstep1.png'
import howstep2 from '../../assets/images/howstep2.png'
import howstep3 from '../../assets/images/howstep3.png'

function HowWork() {
  return (

    <section className="how_it_section white_text">
      <div className="how_it_inner" data-aos="fade-in" data-aos-duration={1500}>
        <div className="dotes_blue">
          <img src={Bluedots} alt="" />
        </div>
        <div className="container">
          <div className="section_title" data-aos="fade-up" data-aos-duration={1500}>
            <span className="title_badge">En 3 étapes simples</span>
            <h2>Comment Neoori fonctionne ?</h2>
          </div>
          <div className="row">
            <div className="col-md-4">
              <div className="steps_block step_border" data-aos="fade-up" data-aos-duration={1500} >
                <div className="steps">
                  <div className="icon">
                    <img src={howstep1} alt="" />
                  </div>
                  <div className="text">
                    <h3>Crée ton compte &amp; ton profil</h3>
                    <ul className="social">
                      <li>
                        <Link to="#">
                          <i className="icofont-email" />
                        </Link>
                      </li>
                      <li>
                        <Link to="#">
                          <i className="icofont-brand-google" />
                        </Link>
                      </li>
                      <li>
                        <Link to="#">
                          <i className="icofont-brand-apple" />
                        </Link>
                      </li>
                    </ul>
                    <p>
                      Crée ton compte et renseigne quelques infos en 2 minutes.
                      <br />
                      Laisse Neoori commencer à te connaître.
                    </p>
                  </div>
                </div>
                <span className="step">01</span>
              </div>
            </div>
            <div className="col-md-4">
              <div className="steps_block step_border" data-aos="fade-up" data-aos-duration={1500}>
                <div className="steps">
                  <div className="icon">
                    <img src={howstep2} alt="" />
                  </div>
                  <div className="text">
                    <h3>Passe tes jeux &amp; tests</h3>
                    <span className="tag_text">Découvre qui tu es vraiment</span>
                    <p>
                      Des mini-jeux rapides pour analyser ton potentiel,
                      tes forces, ton style et tes préférences
                      pro. Fun, rapide, 0 prise de tête.
                    </p>
                  </div>
                </div>
                <span className="step">02</span>
              </div>
            </div>
            <div className="col-md-4">
              <div className="steps_block" data-aos="fade-up" data-aos-duration={1500} >
                <div className="steps">
                  <div className="icon">
                    <img src={howstep3} alt="" />
                  </div>
                  <div className="text">
                    <h3>Obtiens ton plan personnalisé</h3>
                    <span className="tag_text">Ton coach IA te guide</span>
                    <p>
                      Reçois une analyse complète et des recommandations de
                      formations, métiers, offres, actions et contenus adaptés
                      uniquement à toi.
                    </p>
                  </div>
                </div>
                <span className="step">03</span>
              </div>
            </div>
          </div>
          <div className="text-center">
            <div className="btn_block">
              <Link to="/contact" className="btn puprple_btn ml-0">
                Commencer maintenant
              </Link>
              <div className="btn_bottom" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
export default HowWork;
